const languageDropdown = document.querySelector<HTMLSelectElement>(
  "select[name='language']",
);

if (languageDropdown) {
  languageDropdown.addEventListener("change", () => {
    const target = languageDropdown.value;
    const strippedPath = location.pathname.replace(/^\/pt(?=\/|$)/, "") || "/";
    const nextPath =
      target === "pt"
        ? "/pt" + (strippedPath === "/" ? "" : strippedPath)
        : strippedPath;

    location.href = nextPath + location.search + location.hash;
  });
}
